import mapboxgl from "mapbox-gl";
import {
  EventBus
} from "../../data/EventBus";

import {
  Config
} from "../../data/Config/Config";

export default class MapEvents {
  constructor(_mapComponent) {
    this._mapComponent = _mapComponent;
  }

  attachEvents() {
    this._mapComponent.map.on("click", (e) => {
      EventBus.$emit("clear-search");
      this._mapComponent.$store.commit("setSelectedAddress", {});
      this._mapComponent.selectPoint(e, false);
    });

    this._mapComponent.map.on("moveend", () => {
      this._mapComponent.$store.commit("setMapBounds", this._mapComponent.map.getBounds());
      //this._mapComponent.layerManager.updateBoundedLayers(); //Depricated but could be useful if we need to use bounded geojson data
    });

    this._mapComponent.map.on('data', function (d) {
      if (d.sourceId === "tract-cvap-choro-source") {
        //this._mapComponent.$store.commit("setTractsLoading",d.isSourceLoaded)
      }
    });

    this._mapComponent.map.on("load", () => {

      this._mapComponent.$store.commit("setMapBounds", this._mapComponent.map.getBounds());
      if (this._mapComponent.map.loaded()) this._mapComponent.init(); //Why the if(this._mapComponent.map.loaded())? Not sure why but there's probably a reason
      const qo = this._mapComponent.$store.getters.getMarkerLoc;
      if (qo.length > 0 && !this._mapComponent.marker) {
        this._mapComponent.marker = new mapboxgl.Marker()
          .setLngLat([+qo[1], +qo[0]])
          .addTo(this._mapComponent.map);
      }
    });

    this._mapComponent.map.on("zoom", () => {
      this._mapComponent.layerManager.SetChoroplethOpacity(this._mapComponent.opacitySlideValue);
    });
    //this._mapComponent 'select-point' event is JUST for setting the point if it's in the url
    EventBus.$on("select-point-from-url", (pnt) => {

      this._mapComponent.mapSelection.selectFromUrlMarker([pnt.split(",")[1], pnt.split(",")[0]])

    });

    EventBus.$on('select-from-address', (lngLat) => {
      this._mapComponent.mapSelection.selectFromAddressLngLat(lngLat);
    })

    EventBus.$on("select-fips-from-search", (e) => {

      this._mapComponent.mapSelection.selectFromSearchGeoid(e)
    });

    EventBus.$on("select-fips-from-url", (e) => {
      this._mapComponent.mapSelection.selectFromUrlGeoid(e);
    });

    EventBus.$on("clear-data", () => {
      if (this._mapComponent.marker) {
        this._mapComponent.marker.remove();
        this._mapComponent.marker = null;
        this._mapComponent.$store.commit("setMarkerLoc", "-1");
      }
      EventBus.$emit("clear-search");
      this._mapComponent.selectedDistrictNew = "-1";
      this._mapComponent.layerManager.ClearAllHighlights();
    });

    EventBus.$on('toggle-legend-layer', (id, val, isChoroLayer = false) => {
      console.log(id)
      if (id === 'tract-vap' || id === 'tract-cvap' || id === 'voting-precincts') {

        this._mapComponent.layerManager.SetChoroLayerVisibility(val, id);
        // if (val === true) {
        //   if (id === 'tract-cvap') {
        //     this._mapComponent.layerManager.SetChoroLayerVisibility(false, 'voting-precincts');
        //   }
        //   if (id === 'voting-precincts') {
        //     this._mapComponent.layerManager.SetChoroLayerVisibility(false, 'tract-cvap');
        //   }
        // }
        return;
      }
      if (isChoroLayer) {
        Config.layersConfig.choroplethLayerArray.forEach((layer) => {
          if (val) {
            if (layer.id === id) {

              this._mapComponent.map.setLayoutProperty(layer.id, "visibility", "visible");
            } else {
              this._mapComponent.map.setLayoutProperty(layer.id, "visibility", "none");
            }
          } else {
            if (layer.id === this._mapComponent.$store.getters.getDistrictType) {
              this._mapComponent.map.setLayoutProperty(layer.id, "visibility", "visible");
            } else {
              this._mapComponent.map.setLayoutProperty(layer.id, "visibility", "none");
            }
          }

        });
      } else {
        this._mapComponent.map.setLayoutProperty(id, "visibility", val ? "visible" : "none");
      }
    })


  }
}